export default function classNameFn(classes = []) {
  return classes.join(" ").trim();
}